import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getVerticalWallArea as i } from "../total-metrics/index59.js";
import { getRgObjectsAtLevel as m } from "../../../utils/rg-util/index3.js";
import { isAmenityTechSpace as o } from "../../queries/index.js";
const f = (e, t) => i(m(e, r.TechnicalSpace, t).filter(o));
export {
  f as getLevelAmenitiesWallArea
};
//# sourceMappingURL=index3.js.map
